import { getDecodeWeeklyDaysOperation, getDecodeWeeklyHoursOperation } from '@/utilz/shipmentDataManupulation';
import type { DefaultShipmentPickupLocationResponse } from './api';

export const normalizeDefaultShipmentPickupLocation = (location: DefaultShipmentPickupLocationResponse) => {
  if (!location) {
    return null;
  }
  const daysOfWeek = getDecodeWeeklyDaysOperation(location.daysOfWeek);
  const hoursOfOperation = getDecodeWeeklyHoursOperation(location.hoursOfOperation);
  return {
    name: location.name,
    address1: location.addr1,
    address2: location.addr2,
    city: location.city,
    stateName: location.stateDesc,
    stateCode: location.state,
    zipCode: location.zip,
    countryCode: location.countryCode,
    countryName: location.countryName,
    contactName: location.contactName,
    contactEmail: location.contactEmail,
    phone: location.phone,
    extension: location.phoneExt,
    appointmentType: location.appointmentType,
    searchId: location.searchId,
    fromOperationDay: daysOfWeek.fromOperationDay,
    toOperationDay: daysOfWeek.toOperationDay,
    fromOperationHours: hoursOfOperation.fromOperationHours,
    toOperationHours: hoursOfOperation.toOperationHours,
  };
};
